import { Mail, Phone, MapPin } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function ContactPage() {
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-[#007AFF] text-white py-24 text-center">
        <div className="w-4/5 mx-auto">
          <h1 className="text-2xl sm:text-5xl md:text-5xl font-bold mb-2 mt-[20px]">
            Contact Us
          </h1>
          <p className="text-m sm:text-lg md:text-lg max-w-2xl mx-auto">
            We’d love to hear from you. Reach out for inquiries, support, or
            collaborations.
          </p>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-20 w-4/5 mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
        <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
          <Mail className="w-12 h-12 text-[#007AFF] mx-auto mb-4" />
          <h3 className="text-lg sm:text-xl md:text-xl font-semibold mb-2">
            Email Us
          </h3>
          <p className="text-gray-600">Dottiverify.com@gmail.com</p>
        </div>
        <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
          <Phone className="w-12 h-12 text-[#007AFF] mx-auto mb-4" />
          <h3 className="text-lg sm:text-xl md:text-xl font-semibold mb-2">
            Call Us
          </h3>
          <p className="text-gray-600">+234 8028511567</p>
        </div>
        <div className="bg-white p-8 rounded-2xl shadow hover:shadow-lg transition">
          <MapPin className="w-12 h-12 text-[#007AFF] mx-auto mb-4" />
          <h3 className="text-lg sm:text-xl md:text-xl font-semibold mb-2">
            Visit Us
          </h3>
          <p className="text-gray-600">Lagos, Nigeria</p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
